var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.sum) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "calc(33vw - 100px)",
      "text-align": "center",
      "padding": "50px 0"
    }
  }, [_c('div', [_vm._v("收货金额合计（元）")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.session.permission.baobiaojiage ? _vm.AmountDecimal(_vm.sum['wupin.yishouhuojinehanshui'], 2) : '--'))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "calc(33vw - 100px)",
      "text-align": "center",
      "padding": "50px 0"
    }
  }, [_c('div', [_vm._v("退货金额合计（元）")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.session.permission.baobiaojiage ? _vm.AmountDecimal(_vm.sum['wupin.tuihuojinehanshui'], 2) : '--'))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "calc(33vw - 100px)",
      "text-align": "center",
      "padding": "50px 0"
    }
  }, [_c('div', [_vm._v("实收金额合计（元）")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.session.permission.baobiaojiage ? _vm.AmountDecimal(_vm.sum['wupin.yishouhuojinehanshui'] - _vm.sum['wupin.tuihuojinehanshui'], 2) : '--'))])])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0379b4c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/MoneyTotal/index.vue
// module id = zuG6
// module chunks = 142